// Kullanılmış / süresi dolmuş / geçersiz davet-sıfırlama bağlantısı ekranı (AuthShell içinde).
// Metinler lib/activation-link-ui.ts'ten — sayfa içinde satır içi kopya yazılmaz.

import { Link } from "react-router-dom";
import { activationNoticeCopy, type ActivationLinkKind } from "../../lib/activation-link-ui";

interface Props {
  status: "used" | "expired" | "invalid";
  kind: ActivationLinkKind;
}

export function ActivationLinkNotice({ status, kind }: Props): JSX.Element {
  const copy = activationNoticeCopy(status, kind);
  const isUsed = status === "used";
  return (
    <div data-testid="activation-link-notice" data-status={status}>
      <h2
        className="text-2xl mb-2"
        style={{
          fontFamily: "var(--font-display)",
          color: isUsed ? "var(--color-text)" : "var(--color-error)",
        }}
      >
        {copy.title}
      </h2>
      <p className="mb-6" role="status" style={{ color: "var(--color-text-2)" }}>
        {copy.body}
      </p>
      <div className="flex flex-wrap items-center gap-3">
        {copy.primary ? (
          <Link
            to={copy.primary.to}
            className="inline-block px-4 py-2.5 rounded-lg font-medium"
            style={{ background: "var(--color-primary)", color: "var(--color-surface)" }}
          >
            {copy.primary.label}
          </Link>
        ) : null}
        {copy.secondary ? (
          <Link
            to={copy.secondary.to}
            className="inline-block px-4 py-2.5 rounded-lg font-medium"
            style={{
              background: "transparent",
              border: "1px solid var(--color-border)",
              color: "var(--color-text)",
            }}
          >
            {copy.secondary.label}
          </Link>
        ) : null}
      </div>
    </div>
  );
}

/** Kontrol sürerken kısa durum satırı (form gizli). */
export function ActivationLinkChecking({ text }: { text: string }): JSX.Element {
  return (
    <p role="status" aria-live="polite" style={{ color: "var(--color-text-2)" }}>
      {text}
    </p>
  );
}
